import { toBatchListResponse } from "../batchAdapters";

export const localDateValue = (date = new Date()) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

// Convert the operator's local calendar day and time range to UTC API bounds.
// A range crossing midnight belongs to the selected day's overnight shift.
export const toBatchFilterParams = (filters) => {
  const params = {
    line_id: filters.line || undefined,
    machine_type: filters.machineType || undefined,
    machine_id: filters.machine || undefined,
    shift_id: filters.shift || undefined,
  };
  if (filters.date || filters.timeFrom || filters.timeTo) {
    const date = filters.date || localDateValue();
    const start = new Date(`${date}T${filters.timeFrom || "00:00"}:00`);
    const end = new Date(`${date}T${filters.timeTo || "23:59"}:59.999`);
    if (end < start) end.setDate(end.getDate() + 1);
    if (!Number.isNaN(start.getTime())) params.created_at_from = start.toISOString();
    if (!Number.isNaN(end.getTime())) params.created_at_to = end.toISOString();
  }
  return params;
};

export const loadBatchExportRows = async (list, params) => {
  const rows = [];
  const seen = new Set();
  for (let page = 1; ; page += 1) {
    const response = await list({ ...params, page, limit: 200 });
    if (response?.status === "failed") throw new Error(response.message || "Unable to export batches.");
    const result = toBatchListResponse(response);
    if (!result.rows.length) break;
    const nextRows = result.rows.filter((row) => !seen.has(row.uid));
    if (!nextRows.length) throw new Error("Unable to load the next page of batches for export.");
    nextRows.forEach((row) => seen.add(row.uid));
    rows.push(...nextRows);
    if (rows.length >= result.total) break;
  }
  return rows;
};
